import { call, take, takeLatest } from "redux-saga/effects";
import {
  PERMISSION_LIST,
  SUPER_USER_CREATE,
  SUPER_USER_DELETE,
  SUPER_USER_DETAIL,
  SUPER_USER_EDIT,
  SUPER_USER_LIST,
  SUPER_USER_PERMISSION_LIST,
  SUPER_USER_VERSION_DETAIL,
  SUPER_USER_VERSION_LIST,
  SUPER_USER_ROLE_LIST,
  SUPER_USER_ROLE_CREATE,
  SUPER_USER_ROLE_EDIT,
  SUPER_USER_ROLE_DELETE,
  SUPER_USER_ROLE_VERSION_LIST,
  SUPER_USER_ROLE_VERSION_DETAIL,
  PERMISSION_ROLE_LIST,
  SUPER_USER_ROLE_DETAIL,
  ROLE_LIST,
} from "../actions/types";
import * as superUserApis from "../apis/superUserApis";

export function* superUserListWorker(action) {
  try {
    const res = yield call(superUserApis.superUserListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserDetailWorker(action) {
  try {
    const res = yield call(superUserApis.superUserViewApi, {
      super_user_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserCreateWorker(action) {
  try {
    const res = yield call(superUserApis.superUserCreateApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserEditWorker(action) {
  try {
    const res = yield call(superUserApis.superUserEditApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserDeleteWorker(action) {
  try {
    const res = yield call(superUserApis.sueprUserDeleteApi, {
      super_user_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserVersionListWorker(action) {
  try {
    const res = yield call(superUserApis.superUserVersionListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserVersionDetailWorker(action) {
  try {
    const res = yield call(superUserApis.superUserVersionDetailApi, {
      super_user_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserPermissionListWorker(action) {
  try {
    const res = yield call(superUserApis.superUserPermissionListApi);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchPermissionListWorker(action) {
  try {
    const res = yield call(superUserApis.permissionListApi);
    if (res.status == "200") {
      let newArr = res.data.data.permissionModules.map((ele) => ({
        value: ele.id,
        label: ele.module_name,
      }));
      // .filter((ex) => ex.label != "Setting");
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserRoleDetailWorker(action) {
  try {
    const res = yield call(superUserApis.superUserRoleViewApi, {
      role_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserRoleListWorker(action) {
  try {
    const res = yield call(superUserApis.superUserRoleListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserRoleCreateWorker(action) {
  try {
    const res = yield call(superUserApis.superUserRoleCreateApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserRoleEditWorker(action) {
  try {
    const res = yield call(superUserApis.superUserRoleEditApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserRoleDeleteWorker(action) {
  try {
    const res = yield call(superUserApis.superUserRoleDeleteApi, {
      role_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserRoleVersionListWorker(action) {
  try {
    const res = yield call(
      superUserApis.superUserRoleVersionListApi,
      action.data
    );
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserRoleVersionDetailWorker(action) {
  try {
    const res = yield call(superUserApis.superUserRoleVersionDetailApi, {
      role_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchRolePermissionListWorker(action) {
  try {
    const res = yield call(superUserApis.permissionRoleListApi);
    if (res.status == "200") {
      let newArr = res.data.data.permissionModules.map((ele) => ({
        id: ele.id,
        label: ele.module_name,
      }));
      // .filter((ex) => ex.label != "Setting");
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* fetchRoleListWorker(action) {
  try {
    const res = yield call(superUserApis.roleListApi);
    if (res.status == "200") {
      console.log(res);
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.role_name,
        level: ele.role_level,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* superUserPermissionListWatcher() {
  yield takeLatest(SUPER_USER_PERMISSION_LIST, superUserPermissionListWorker);
}

export function* superUserListWatcher() {
  yield takeLatest(SUPER_USER_LIST, superUserListWorker);
}

export function* superUserDetailWatcher() {
  yield takeLatest(SUPER_USER_DETAIL, superUserDetailWorker);
}

export function* superUserCreateWatcher() {
  yield takeLatest(SUPER_USER_CREATE, superUserCreateWorker);
}

export function* superUserEditWatcher() {
  yield takeLatest(SUPER_USER_EDIT, superUserEditWorker);
}

export function* superUserDeleteWatcher() {
  yield takeLatest(SUPER_USER_DELETE, superUserDeleteWorker);
}

export function* superUserVersionListWatcher() {
  yield takeLatest(SUPER_USER_VERSION_LIST, superUserVersionListWorker);
}

export function* superUserVersionDetailWatcher() {
  yield takeLatest(SUPER_USER_VERSION_DETAIL, superUserVersionDetailWorker);
}

export function* fetchPermissionListWatcher() {
  yield takeLatest(PERMISSION_LIST, fetchPermissionListWorker);
}

export function* superUserRoleListWatcher() {
  yield takeLatest(SUPER_USER_ROLE_LIST, superUserRoleListWorker);
}

export function* superUserRoleCreateWatcher() {
  yield takeLatest(SUPER_USER_ROLE_CREATE, superUserRoleCreateWorker);
}

export function* superUserRoleEditWatcher() {
  yield takeLatest(SUPER_USER_ROLE_EDIT, superUserRoleEditWorker);
}

export function* superUserRoleDeleteWatcher() {
  yield takeLatest(SUPER_USER_ROLE_DELETE, superUserRoleDeleteWorker);
}

export function* superUserRoleVersionListWatcher() {
  yield takeLatest(
    SUPER_USER_ROLE_VERSION_LIST,
    superUserRoleVersionListWorker
  );
}

export function* superUserRoleVersionDetailWatcher() {
  yield takeLatest(
    SUPER_USER_ROLE_VERSION_DETAIL,
    superUserRoleVersionDetailWorker
  );
}

export function* fetchRolePermissionListWatcher() {
  yield takeLatest(PERMISSION_ROLE_LIST, fetchRolePermissionListWorker);
}

export function* superUserRoleDetailWatcher() {
  yield takeLatest(SUPER_USER_ROLE_DETAIL, superUserRoleDetailWorker);
}
export function* fetchRoleListWatcher() {
  yield takeLatest(ROLE_LIST, fetchRoleListWorker);
}
